// app/javascript/controllers/admin_user_flash_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { delay: Number }

    connect() {
        if (this.delayValue > 0) {
            setTimeout(() => {
                this.dismiss()
            }, this.delayValue)
        }
    }

    dismiss() {
        this.element.style.transition = 'opacity 0.3s ease-out'
        this.element.style.opacity = '0'

        setTimeout(() => {
            this.element.remove()
        }, 300)
    }
}